import { marketplaceStateTone } from "@nova-ai/shared"

/** Human display name for a marketplace id: "decathlon-pl" → "Decathlon PL".
 *  Pieces of one or two characters read as country/region codes and go
 *  uppercase; everything else is capitalised. */
export function humanizeMarketplaceId(id: string): string {
  return id
    .split("-")
    .map((piece) => {
      if (piece.length <= 2) {
        return piece.toUpperCase()
      }
      return piece.charAt(0).toUpperCase() + piece.slice(1)
    })
    .join(" ")
}

type MarketplaceChipKind = "good" | "warn" | "bad" | "info"

const MARKETPLACE_TONE_CHIP = {
  success: "good",
  progress: "info",
  attention: "warn",
  failure: "bad",
} as const satisfies Record<
  NonNullable<ReturnType<typeof marketplaceStateTone>>,
  MarketplaceChipKind
>

/** Maps the shared marketplace lifecycle vocabulary into Nova's UI tones. */
export function marketplaceChipKind(state: string | null | undefined): MarketplaceChipKind | null {
  const tone = marketplaceStateTone(state)
  return tone ? MARKETPLACE_TONE_CHIP[tone] : null
}
